import { useState, useEffect } from 'react';

var useDetectWrapping = function (containerRef) {
    var _a = useState(false), wrap = _a[0], setWrap = _a[1];
    useEffect(function () {
        var detectWrap = function () {
            var _a, _b, _c;
            var children = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.children;
            if (children) {
                var totalChildrenWidth = Array.from(children).reduce(function (acc, child) { return acc + child.clientWidth; }, 0);
                var containerWidth = (_c = (_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) !== null && _c !== void 0 ? _c : 0;
                var remainingWidth = containerWidth - totalChildrenWidth;
                setWrap(remainingWidth < 0);
            }
        };
        detectWrap();
        window.addEventListener("resize", detectWrap);
        return function () {
            window.removeEventListener("resize", detectWrap);
        };
    }, []);
    return wrap;
};

export { useDetectWrapping as default, useDetectWrapping };
